import { z } from 'zod/v4';

import { simpleVehicleGroupSchema } from './vehicle-group.schema';

export const avoidFavorSetSchema = z.object({
  name: z.string(),
  vehicleGroups: z.array(simpleVehicleGroupSchema),
  setId: z.number(),
  isDefault: z.boolean(),
});

export type AvoidFavorSet = z.infer<typeof avoidFavorSetSchema>;
